import { POST } from '@/api'
import { cloneDeep, isEmpty, toString, uniqBy } from 'lodash'
import { getAttributesStrListByCodeAndType } from '@/resources/customer/attributesMap'

const CONTIDION = {
  isEnable: false,
  sortType: 0,
  attributes: [],
  supplementaryType: 2,
  visitCount: 0,
  visitCondition: 0,
  registerDate: 0,
  start: 0,
  limit: 20,
}

export default {
  namespaced: true,
  state: {
    searchWord: '',
    condition: { ...CONTIDION },
    customerList: [],
    isGetCustomerByConditionBusy: false,
    isGetCustomerByConditionEnd: false,
    isCustomerInputVisible: false,
    customerSelectSearchWord: '',
    customerSelectCondition: { ...CONTIDION },
    customerSelectList: [],
    isGetCustomerSelectBusy: false,
    isGetCustomerSelectEnd: false,
  },
  mutations: {
    updateSearchWord(state, value) {
      state.searchWord = value
    },
    enableCondition(state) {
      state.condition.isEnable = true
    },
    disableCondition(state) {
      state.condition.isEnable = false
    },
    updateConditionStart(state, value) {
      state.condition.start = value
    },
    updateCondition(state, value) {
      state.condition = { ...state.condition, ...value }
    },
    clearCondition(state) {
      state.condition = { ...CONTIDION }
    },
    updateCustomerList(state, { index, value }) {
      state.customerList.splice(index, value.length, ...value)
    },
    updateCustomerListById(state, customer) {
      const index = state.customerList.findIndex(({ id }) => id === customer.id)
      if (index !== -1) {
        state.customerList.splice(index, 1, { ...state.customerList[index], ...customer })
      }
    },
    updateCustomerListAll(state, value) {
      state.customerList = value
    },
    updateIsGetCustomerByConditionBusy(state, value) {
      state.isGetCustomerByConditionBusy = value
    },
    updateIsGetCustomerByConditionEnd(state, value) {
      state.isGetCustomerByConditionEnd = value
    },
    showCustomerInput(state) {
      state.isCustomerInputVisible = true
    },
    hideCustomerInput(state) {
      state.isCustomerInputVisible = false
    },
    updateIsPostCustomerBusy(state, value) {
      state.isPostCustomerBusy = value
    },
    updateCustomerSelectSearchWord(state, value) {
      state.customerSelectSearchWord = value
    },
    updateCustomerSelectConditionStart(state, value) {
      state.customerSelectCondition.start = value
    },
    updateCustomerSelectConditionLimit(state, value) {
      state.customerSelectCondition.limit = value
    },
    updateCustomerSelectList(state, value) {
      state.customerSelectList = value
    },
    updateIsGetCustomerSelectBusy(state, value) {
      state.isGetCustomerSelectBusy = value
    },
    updateIsGetCustomerSelectEnd(state, value) {
      state.isGetCustomerSelectEnd = value
    },
  },
  actions: {
    updateCustomerOfList({ state, commit }, { src, supplementaryType }) {
      const targetIndex = state.customerList.findIndex(customer => customer.id === src.id)
      if (targetIndex < 0) return
      const target = cloneDeep(state.customerList[targetIndex])

      if (src.lastName || src.firstName) {
        target.name = `${toString(src.lastName)}${!isEmpty(src.lastName) ? ' ' : ''}${toString(src.firstName)}`
      } else if (src.lastNameKana || src.firstNameKana) {
        target.name = `${toString(src.lastNameKana)}${!isEmpty(src.lastNameKana) ? ' ' : ''}${toString(
          src.firstNameKana,
        )}`
      } else if (src.tel1) {
        target.name = src.tel1
      } else if (src.tel2) {
        target.name = src.tel2
      }

      switch (supplementaryType) {
        case 0:
          target.supplementary = src.officeName
          break
        case 1:
          if (src.lastName || src.firstName || src.lastNameKana || src.firstNameKana) {
            if (src.tel1 && src.tel2) {
              target.supplementary = `${src.tel1}/${src.tel2}`
            } else if (src.tel1) {
              target.supplementary = src.tel1
            } else if (src.tel2) {
              target.supplementary = src.tel2
            } else {
              target.supplementary = ''
            }
          } else if (src.tel1 && src.tel2) {
            target.supplementary = src.tel2
          } else {
            target.supplementary = ''
          }
          break
        default:
          break
      }

      target.attributes.bad = getAttributesStrListByCodeAndType(src.attributes, 'bad')
      target.attributes.normal = getAttributesStrListByCodeAndType(src.attributes, 'normal')

      commit('updateCustomerList', { index: targetIndex, value: [target] })
    },
    async getCustomerByCondition(store) {
      const { commit, state } = store

      if (state.isGetCustomerByConditionBusy) return false

      commit('updateIsGetCustomerByConditionBusy', true)
      commit('updateIsGetCustomerByConditionEnd', false)

      const condition = state.condition
      const { status, message, data } = await POST('/api/web/customer/search', {
        searchWord: state.searchWord,
        sortType: condition.sortType,
        attributes: condition.attributes,
        supplementaryType: condition.supplementaryType,
        visitCount: condition.visitCount,
        visitCondition: condition.visitCondition,
        registerDate: condition.registerDate,
        start: condition.start,
        limit: condition.limit,
      })

      if (status !== 200) {
        commit('updateIsGetCustomerByConditionEnd', true)
        if (status !== 404) {
          commit('app/error', { status, message }, { root: true })
        }
      }

      if (status === 200 && data) {
        commit('updateCustomerListAll', state.customerList.concat(data.customer))

        if (data.pagenation.next) {
          commit('updateConditionStart', data.pagenation.next)
        } else {
          commit('updateIsGetCustomerByConditionEnd', true)
        }
      }

      commit('updateIsGetCustomerByConditionBusy', false)
      return status === 200
    },
    async getCustomerSelectList(store) {
      const { commit, state } = store

      if (state.isGetCustomerByConditionBusy) return false

      commit('updateIsGetCustomerSelectBusy', true)
      commit('updateIsGetCustomerSelectEnd', false)

      const condition = state.customerSelectCondition
      const { status, message, data } = await POST('/api/web/customer/search', {
        searchWord: state.customerSelectSearchWord,
        sortType: condition.sortType,
        attributes: condition.attributes,
        supplementaryType: 1,
        visitCount: condition.visitCount,
        visitCondition: condition.visitCondition,
        registerDate: condition.registerDate,
        start: condition.start,
        limit: condition.limit,
      })

      if (status !== 200) {
        commit('updateIsGetCustomerSelectEnd', true)
        if (status !== 404) {
          commit('app/error', { status, message }, { root: true })
        }
      }

      if (status === 200 && data) {
        const searchList = !condition.start ? data.customer : [...state.customerSelectList, ...data.customer]
        commit('updateCustomerSelectList', uniqBy(searchList, 'id'))

        if (data.pagenation.next) {
          commit('updateCustomerSelectConditionStart', data.pagenation.next)
        } else {
          commit('updateIsGetCustomerSelectEnd', true)
        }
      }

      commit('updateIsGetCustomerSelectBusy', false)
      return status === 200
    },
  },
}
